import type { ReactNode } from 'react'
import { useNotificationRealtime } from './realtime'

export function NotificationsProvider({ children }: { children: ReactNode }) {
  useNotificationRealtime()
  return children
}
